"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasRelationships = exports.hasRelated = exports.hasIncluded = exports.hasLinks = exports.isSuccess = exports.isBatchAction = exports.isBatchMeta = void 0;
function isBatchMeta(meta) {
    return Boolean(meta && (meta.op || meta["batch-key"]));
}
exports.isBatchMeta = isBatchMeta;
function isBatchAction(val) {
    return "action" in val;
}
exports.isBatchAction = isBatchAction;
function isSuccess(document) {
    return document.data !== undefined;
}
exports.isSuccess = isSuccess;
function hasLinks(document) {
    return document.links !== undefined;
}
exports.hasLinks = hasLinks;
function hasIncluded(document) {
    return document.included !== undefined;
}
exports.hasIncluded = hasIncluded;
function hasRelated(links) {
    return links.related !== undefined;
}
exports.hasRelated = hasRelated;
function hasRelationships(data) {
    return data.relationships !== undefined;
}
exports.hasRelationships = hasRelationships;
//# sourceMappingURL=index.js.map